import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PriceTierDeleteCard } from './components/PriceTierDeleteCard';
import { PriceTierDetailsCard } from './components/PriceTierDetailsCard';

// import { ProductsCard } from './components/ProductsCard';

export function PriceTierDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const priceTierQueryResults = useQuery({
        queryKey: ['priceTier', id],
        queryFn: () => Api.Core.PriceTier.getPriceTier(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={priceTierQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <PriceTierDetailsCard priceTier={data} />

                            <Can I="delete" a="PriceTier">
                                <PriceTierDeleteCard priceTier={data} />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
